import { DeleteIcon } from "@chakra-ui/icons";
import { Tr, Td, IconButton } from "@chakra-ui/react";
import { motion } from "framer-motion";

const MotionTr = motion(Tr); // Создаем анимированный компонент для строки таблицы

const RecentCheckItem = ({ check, onClick, onDelete }) => {
	return (
		<MotionTr
			onClick={() => onClick(check.address)}
			cursor="pointer"
			initial={{ x: 0 }} // Изначальная позиция
			exit={{ x: -100, opacity: 0 }} // Сдвигаем влево и уменьшаем непрозрачность
			transition={{ duration: 0.3 }} // Продолжительность анимации
		>
			<Td isTruncated width="20%">
				{`${check.address.slice(0, 6)}...${check.address.slice(-4)}`}
			</Td>
			<Td textAlign="center" width="10%">#{check.rank}</Td>
			<Td textAlign="center" width="10%">{check.badgeCount}</Td>
			<Td textAlign="center" width="15%">Top {Math.ceil(check.percentage)}%</Td>
			<Td width="5%">
				<IconButton
					aria-label="Delete"
					icon={<DeleteIcon />}
					onClick={(e) => {
						e.stopPropagation();
						onDelete(check.address);
					}}
					size="sm"
					colorScheme="red"
					variant="ghost"
					color={"#FF684B"}
					opacity={0.8}
				/>
			</Td>
		</MotionTr>
	);
};

export default RecentCheckItem;
